// Index file: re-export all APIs from their dedicated files
// Re-export utility functions
export { getToken, setToken, removeToken } from './axios.js';
// Re-export API modules
export * from './apis/recipeApis.js';
export * from './apis/shopApis.js';
export * from './apis/orderApis.js';
export * from './apis/ordersSSE.js';
import { celebMatchingApi } from './apis/kioskServiceApis.js';
import { voiceSommelierApi } from './apis/voiceSommelierApi.js';
import { voiceProfilesApi } from './apis/voiceProfilesApi.js';
import { storyTreeApi } from './apis/storyTreeApi.js';
import { ezPairingApi } from './apis/ezPairingApi.js';
import { vibesMatchingApi } from './apis/vibesMatchingApi.js';
import { translationApi } from './apis/translationApi.js';
import { llmApi } from './apis/llmApi.js';
export * from './apis/mbtiApi.js';
export * from './apis/mbtiMediaApi.js';
export { celebMatchingApi };
export { voiceSommelierApi };
export { voiceProfilesApi };
export { storyTreeApi };
export { ezPairingApi };
export { vibesMatchingApi };
export { translationApi };
export { llmApi };
export * from './apis/kioskTypeApis.js';
export * from './apis/kioskInstanceApi.js';
export { getRecipeIngredientNames, getRecipeIngredientNamesWithTranslations } from './recipes.js';
export * from './translationHelpers.js';
export * from './chartSizing.js';
// Re-export order enums
export { ORDER_STATUS_OPTIONS, ORDER_SIZE_OPTIONS } from '../types/api-types.js';
// Import API modules
import { shopApi } from './apis/shopApis.js';
import { kioskInstanceApi } from './apis/kioskInstanceApi.js';
import { kioskTypeApi } from './apis/kioskTypeApis.js';
import { recipeApi } from './apis/recipeApis.js';
import { xoxoApi } from './axios.js';
// Export combined API objects
export const kioskApi = {
    ...kioskInstanceApi,
    ...kioskTypeApi,
    ...recipeApi
};
export const orderDefaultsApi = {
    get: (shopId) => {
        return shopApi.getShopById(shopId).then(response => ({
            quantity: response.data.order_default_quantity,
            size: response.data.order_default_size,
            status: response.data.order_default_status
        }));
    },
    update: (shopId, data) => shopApi.updateOrderDefaults(shopId, data)
};
export const authApi = {
    login: (credentials) => xoxoApi.post('/auth/login', credentials),
    refreshToken: (refreshToken) => xoxoApi.post('/auth/refresh-tokens', { refreshToken })
};
// Export kiosk types seed API
export const kioskTypesSeedApi = {
    reseedKioskTypes: async () => {
        try {
            const response = await kioskTypeApi.reseedKioskTypes();
            return { data: response };
        }
        catch (error) {
            console.error('Error in kioskTypesSeedApi:', error);
            throw error;
        }
    }
};
// Explicit re-exports for newer MBTI async helpers
export { generateMBTIMappingsAsync, generateMBTIBarExplanationsAsync, getMBTIJob, generateTravel3Image, generateTravel3Video, checkTravel3Quota, uploadBase64Selfie, uploadToPhotowall } from './apis/mbtiApi.js';
